
export default {
    name: 'ScrollContainer',
    props: {
        containerIsWindow: {
            type: Boolean,
            default: () => false
        },
        paddingTop: {
            type: Number,
            default: () => 0
        },
        almostPixels: {
            type: Number,
            default: () => null
        },
        almostDebounceInSeconds: {
            type: Number,
            default: () => 50
        }
    },
    data () {
        return {
            scrollContainer: null,
            isNavigating: false,
            debounce: null,
            almostPixelsValue: this.almostPixels,
            clearIsNavigationTimeout: null
        }
    },
    mounted () {
        let supportsPassive = false
        if (typeof window !== 'undefined') {
            supportsPassive = false
            try {
                const opts = Object.defineProperty({}, 'passive', {
                    get () {
                        supportsPassive = true
                    }
                })
                window.addEventListener('test', null, opts)
            } catch (e) {}
        }

        this.scrollContainer = this.containerIsWindow ? document.documentElement : this.$el
        if (this.almostPixels === null) {
            this.almostPixelsValue = Math.round(this.scrollContainer.clientHeight / 2)
        }
        const sc = this.containerIsWindow ? window : this.scrollContainer
        if (this.scrollContainer) {
            sc.addEventListener('scroll', this.scrollStopped, supportsPassive ? { passive: true } : {})
        }
    },
    beforeDestroy () {
        const sc = this.containerIsWindow ? window : this.scrollContainer
        sc.removeEventListener('scroll', this.scrollStopped)
    },
    methods: {
        scrollStopped () {
            clearTimeout(this.debounce)
            this.debounce = setTimeout(() => {
                if (this.isNavigating) {
                    return
                }

                if (this.scrollContainer.scrollTop <= this.almostPixelsValue) {
                    this.$emit('almost-up')
                } else if (this.scrollContainer.scrollTop >= this.scrollContainer.scrollHeight - this.scrollContainer.clientHeight - this.almostPixelsValue) {
                    this.$emit('almost-down')
                }
            }, this.almostDebounceInSeconds)
        },
        scrollToElement (querySelector, isCenter = true) {
            this.isNavigating = true
            const el = this.$el.querySelector(querySelector)?.getBoundingClientRect().top
            if (el !== undefined) {
                let top = this.$el.querySelector(querySelector)?.getBoundingClientRect().top - this.scrollContainer.getBoundingClientRect().top - this.paddingTop

                if (this.containerIsWindow === false) {
                    top = this.scrollContainer.scrollTop + top
                }
                if (isCenter) {
                    top -= Math.round(this.scrollContainer.clientHeight / 2)
                }
                this.scrollContainer.scrollTo({ top, behavior: 'instant' })
            }
            this.clearIsNavigation()
        },
        scrollToEnd () {
            this.isNavigating = true
            this.scrollContainer.scrollTo({
                top: this.scrollContainer.scrollHeight,
                behavior: 'instant'
            })
            this.clearIsNavigation()
        },
        isScrollAtTheEnd () {
            return ((this.scrollContainer.scrollTop + this.scrollContainer.clientHeight) === this.scrollContainer.scrollHeight) ||
            (this.scrollContainer.scrollTop === 0 && this.scrollContainer.clientHeight === this.scrollContainer.scrollHeight)
        },
        clearIsNavigation () {
            clearTimeout(this.clearIsNavigationTimeout)
            this.clearIsNavigationTimeout = setTimeout(() => {
                this.isNavigating = false
            }, this.almostDebounceInSeconds + 5)
        },
        persistScroll (callback) {
            return new Promise((resolve, reject) => {
                this.isNavigating = true
                try {
                    const { scrollTop, scrollHeight } = this.scrollContainer
                    callback()
                    this.$nextTick(() => {
                        const scrollDiff = this.scrollContainer.scrollHeight - scrollHeight
                        this.scrollContainer.scrollTo({ top: scrollTop + scrollDiff, behavior: 'instant' })
                        this.clearIsNavigation()
                        resolve(true)
                    })
                } catch (e) {
                    this.clearIsNavigation()
                    reject(e)
                }
            })
        }
    }
}
